var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-container"},[_c('PlaylistFrame',{attrs:{"playlist":_vm.$store.deviceStartData.main_play_list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }